import Dashboard from './DictionaryOfPermission/Dashboard'
import Product from './DictionaryOfPermission/Product';
import ProductDetail from './DictionaryOfPermission/ProductDetail';
import BOM from './DictionaryOfPermission/BOM';
import Alerts from './DictionaryOfPermission/Alerts';
import Forecast from './DictionaryOfPermission/Forecast';
import Quote from './DictionaryOfPermission/Quote';
import Order from './DictionaryOfPermission/Order';

class ZxFieldEngineer {

    static register = {
        ...Product.register_guest,
        ...ProductDetail.register_guest,
        ...Forecast.register,
        ...{[Dashboard.register.DBD_BOM_SUMMARY.slug]: Dashboard.register.DBD_BOM_SUMMARY},
        ...{[Product.register_external.PD_ADD_TO_BOM.slug]: Product.register_external.PD_ADD_TO_BOM},
        ...{[ProductDetail.register_external.PDT_ADD_TO_BOM.slug]: ProductDetail.register_external.PDT_ADD_TO_CART},
        ...{[BOM.register_external.VIEW_BOM.slug]: BOM.register_external.VIEW_BOM},
        ...{[Alerts.register.AL_VIEW.slug]: Alerts.register.AL_VIEW},
        ...{[Quote.register.OPEN_QT_VIEW.slug]: Quote.register.OPEN_QT_VIEW},
        ...{[Quote.register.QT_VIEW.slug]: Quote.register.QT_VIEW},
        ...Order.register
    };
    static avUserInfoName = 'ZX';

}

export default ZxFieldEngineer;